import React from "react";
import Upload from "../../../../upload/Upload";
import { Image } from "antd";
import { useTranslation } from "react-i18next";
import { ReactComponent as CloseIcon } from "@/assets/icons/close.svg";

import "@/assets/addLipShape.less";

const AddLipShapeFileRender = ({ imageAccept, currFile, uploadHasEmailCallback,handleCloseCurrFile }) => {
  const { t } = useTranslation(["addLipShape"]);
  return (
    <div className="step-con">
      <div className="step-header">
        <span className="step-num active">
          <span>1</span>
        </span>
        {t('Upload a photo')}
      </div>
      <div className="upload-cont">
        {currFile && currFile.uploadStatus ? (
          <div className="upload-succ">
            <div className="upload-succ-pic-cont">
              <CloseIcon className="close-icon" onClick={handleCloseCurrFile} />
              <Image src={currFile.videofileurl} preview={false} />
            </div>
            <div>
              <h3>{t('Uploaded successfully!')}</h3>
              <p>{t('Please select a template below')}</p>
            </div>
          </div>
        ) : (
          <Upload
            size="thin"
            theme="light"
            visible
            accept={imageAccept}
            work="addLipShape"
            isCropPreload
            isShowUploadProcess
            hideCancelText
            uploadBtnText={t("Upload a photo")}
            uploadNoteText = {t('please make sure the face in the photos you selected is facing the lens, otherwise it cannot be processed successfully.')}
            uploadHasEmailCallback={uploadHasEmailCallback}
          />
        )}
      </div>
    </div>
  );
};

export default AddLipShapeFileRender;
